// Author liang gang qiang
// Date 2021-10-20 09:13:43

import * as model from "@/model/mintalMes/prd/MintalMesPrdCraftModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdCraft(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'mintalMesPrdCraft',
        modelFilter: model.filter
    })
    .buildStore()
